import { useCallback } from 'react';

import { useFeatureFlag } from '@/src/application/hooks/util/useFeatureFlag';

import { useActionWhatsAppData } from '@/modules/CampaignsModule/hooks/useActionWhatsAppData';
import { IWhatsAppInfoPayload } from '@/modules/CampaignsModule/interfaces/WhatsApp';

interface IWhatsAppFormEventsProps {
  actionId: number;
}

export const useWhatsAppFormEvents = ({ actionId }: IWhatsAppFormEventsProps) => {
  const { saveInfoWhatsApp } = useActionWhatsAppData(Number(actionId));
  const isTrackingUrlWhatsAppEnabled = useFeatureFlag('enableTrackingUrlWhatsApp');

  const setInfoOnEvent = useCallback(
    (payload: IWhatsAppInfoPayload) =>
      void saveInfoWhatsApp({ ...payload, track: isTrackingUrlWhatsAppEnabled }),
    [saveInfoWhatsApp, isTrackingUrlWhatsAppEnabled]
  );

  return { setInfoOnEvent };
};
